import React from 'react'

import './header.css'

export default () => {

    return (
        <header>
            <label className="title">Jogo da Velha</label>
        </header>
    )

}